/**
 * Main JS Template File
 * @note do not remove //=require and //=include parts. It is parsed by gulp include to manage the files more clear
 */

// gulp-include
//DISABLED=require src/_core.js

$( document ).ready(function() {

    // Toggle Menü
    $( '.togglemenu' ).click(function() {
        $( '.topmenu' ).slideToggle();
    })

    // Fenstergrößen-Änderung
    $(window).resize(function() {
        // Mobile Styles zurücksetzen / desktop
        if ($(window).width() > 749) {
            $( ".topmenu" ).removeAttr('style');
        }
    });

});